import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../constants/Constants";

const removeCookie = (name) => {
  //document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  sessionStorage.removeItem(COOKIE_PARA_NAME_FOR_JOURNEY_ID);
}

export default removeCookie